import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';

import Typography from "@material-ui/core/Typography";
import { IAssessment, IAssessmentProject, IAssessmentSettings, IAssessmentTemplateGroup } from "../types/types";
import {
    Accordion,
    AccordionSummary, Chip, ClickAwayListener,
    Divider, Grow, IconButton, MenuItem, Button,
    Paper, Popper, Toolbar
} from "@material-ui/core";
import { useParams } from "react-router";
import { download, get } from "../fetchers/fetchers";
import { CloudDownload, ExitToApp, ExpandMore } from "@material-ui/icons";
import AssessmentTemplates from "../components/assessment_templates";
import CriticalHazards from "../components/critical_hazards";
import RiskAssessmenets from "../components/risk_assessments";
import ControlMeasures from "../components/control_measuers";
import Harms from "../components/harms";
import ControlMeasureAssessments from "../components/control_measure_assessments";
import ControlMeasureAdequacies from "../components/control_measure_adequacies";
import ControlMeasureCosts from "../components/control_measure_costs";
import AssessmentSettings from "../components/assessment_settings";
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SettingsIcon from '@material-ui/icons/Settings';
import CircularProgress from "@material-ui/core/CircularProgress";

import { useHistory } from "react-router-dom";
import ReasonablyPracticable from "../components/reasonably_practicable_tests";
import FMChart from "../components/fncharts";
import ProjectSettings from "../components/project_settings";
import States from "../components/states";
import SummaryKnowledges from "../components/summary_knowledges";
import SummaryReasonablyPracticable from "../components/summary_reasonably_practicable_tests";
import Investigations from "../components/investigations";
import fileDownload from "js-file-download";
import DamOverview from "../components/dam_overview";
import Likelihoods from "../components/likelihoods";
import Alert from "@material-ui/lab/Alert";
import HelpIcon from "@material-ui/icons/Help"



import { load_data } from "../stateManagement/data";
import ConsequenceCategories from '../components/consequence_information';
import DocumentTable from '../components/document_table';
import SoceitalConcerns from '../components/societal_concerns';

import { APPLICATION } from "../env";
import { render } from '@testing-library/react';
import RPControlMeasures from '../components/rp_control_measure';
import { use } from 'echarts';

const { REACT_APP_BRANCH } = process.env;


interface IAssessmentProps {
    assessment: IAssessmentProject
}

interface IRouteParams {
    id: string
    state?: string
}


const Assessment: FC<IAssessmentProps> = () => {
    const history = useHistory();
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [assessment, setAssessment] = useState<IAssessmentProject>();
    const [topLevelGroup, setTopLevelGroup] = useState<IAssessmentTemplateGroup[]>([]);
    const [assessments, setAssessments] = useState<IAssessment[]>([]);


    const [popperOpen, setPopperOpen] = useState<boolean>(false);

    const [showSettings, setShowSettings] = useState<boolean>(false);
    const [showStates, setShowStates] = useState<boolean>(false);

    const [write_access, setWriteAccess] = useState<boolean>(false);


    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [assessmentSettings, setAssessmentSettings] = useState<IAssessmentSettings>();


    const username = localStorage.getItem("username");

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [expanded, setExpanded] = useState(new Set<string>());

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(prevExpanded => {
            const newExpanded = new Set(prevExpanded); // Create a copy of the current state
            if (isExpanded) {
                newExpanded.add(panel);
            } else {
                newExpanded.delete(panel);
            }
            return newExpanded;
        });
    };

    const params = useParams<IRouteParams>()

    const project_id = assessment?.dam?.project_id || 1

    // console.log("project_id", project_id)

    useEffect(() => {
        load_data(params.id, project_id, dispatch)

    }, [params.id, project_id, dispatch])

    useEffect(() => {
        setIsLoaded(false)
        if (tasks.loaded) {

            setIsLoaded(true)
            setAssessment(tasks.projectAssessment)
            setAssessments(tasks.projectAssessments)
            setTopLevelGroup(tasks.templateGroups)
            setAssessmentSettings(tasks.assessmentSettings)

        }

    }, [tasks.loaded, tasks.projectAssessment, tasks.projectAssessments, tasks.templateGroups, setIsLoaded, setAssessment, setAssessments, setTopLevelGroup])

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks.write_access])

    const renderRiskAssessments = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>

                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <RiskAssessmenets />
                    </Typography>
                }
            </Accordion>
        )

    }

    const renderCriticalFailureMode = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>

                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <CriticalHazards />
                    </Typography>
                }
            </Accordion>
        )

    }


    const renderSummaryReasonablePracticable = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                        <SummaryReasonablyPracticable existing={false} />
                }
            </Accordion>
        )
    }

    const renderInvestigations = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <Investigations />
                    </Typography>
                }
            </Accordion>
        )
    }

    const renderOverview = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <DamOverview />
                    </Typography>
                }
            </Accordion>
        )
    }

    const renderSettings = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <AssessmentSettings />
                    </Typography>
                }
            </Accordion>
        )
    }


    const renderConsequenceCatagory = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <ConsequenceCategories />
                    </Typography>
                }
            </Accordion>
        )
    }

    const renderDocuments = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <DocumentTable />
                    </Typography>
                }
            </Accordion>
        )
    }

    const renderSummaryKnowledge = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>

                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <SummaryKnowledges />
                    </Typography>
                }
            </Accordion>
        )
    }

    const renderControlMeasures = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>

                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <ControlMeasures existing={existing} />
                    </Typography>
                }
            </Accordion>
        )
    }



    const renderFMChart = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>

                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <FMChart />
                    </Typography>
                }
            </Accordion>
        )

    }

    const renderLikelihood = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <Likelihoods />
                    </Typography>
                }
            </Accordion>
        )

    }
    const renderHarm = (index: number, template_group_name: string) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <Harms />
                    </Typography>
                }
            </Accordion>
        )

    }

    const renderControlMeasureAdequacy = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <>


                            <ControlMeasureAssessments existing={existing} considered={true} />
                        </>
                    </Typography>
                }
            </Accordion>
        )

    }

    const renderAdditonalFailureModes = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <ReasonablyPracticable existing={existing} considered={false} additional={true} />
                    </Typography>
                }
            </Accordion>
        )
    }



    const renderReasonablePracticable = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <ReasonablyPracticable existing={existing} considered={true} additional={false} />
                    </Typography>
                }
            </Accordion>
        )
    }


    const renderFailureModeSummary = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <ReasonablyPracticable existing={existing} considered={true} additional={false} control_view={true} />
                    </Typography>
                }
            </Accordion>
        )

    }

    const renderReasonablePracticableCM = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <RPControlMeasures  existing={existing} /> 
                    </Typography>
                }
            </Accordion>
        )

    }

    const renderControlMeasureAdequacyAssessment = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <ControlMeasureAdequacies existing={existing} />
                    </Typography>
                }
            </Accordion>
        )
    }

    const renderSocietalConcerns = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <SoceitalConcerns existing={existing} />
                    </Typography>
                }
            </Accordion>
        )
    }

    const renderControlMeasureCosts = (index: number, template_group_name: string, existing: boolean) => {
        const panelId = `panel${index}`;
        return (
            <Accordion expanded={expanded.has(panelId)} onChange={handleChange(panelId)}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                {expanded.has(panelId) &&
                    <Typography>
                        <ControlMeasureCosts existing={existing} />
                    </Typography>}
            </Accordion>
        )
    }


    const renderSection = (index: number, template_group_name: string, template_group_id: number) => {

        let color = "#535353"
        let bcolor = "rgb(196,196,196)";
        let alpha = 1
        let level_text = "undefined"

        let group_assessments = assessments.filter((a) => {
            return a.assessment_template_detail?.template.group.name === template_group_name
        })

        let min_level = 0

        group_assessments.map(ga => {
            if (!ga.assessment_template_detail)
                return
            if (min_level < ga.assessment_template_detail?.adequacy.level) {
                min_level = ga.assessment_template_detail?.adequacy.level
            }
        })


        if (min_level === 1) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";
            level_text = "Adequate";
        }
        if (min_level === 2) {
            bcolor = "rgba(252,236,166," + alpha + ")";
            color = "rgb(152,96,34)";
            level_text = "Questionable"
        }
        if (min_level === 3) {
            bcolor = "rgba(251,84,81," + alpha + ")";
            color = "rgb(104,4,0)";
            level_text = "Inadequate";
        }


        return (<Accordion>

            <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                <Typography variant="h6"> {template_group_name} </Typography>

                <div style={{ marginLeft: "auto", marginRight: 0 }}>
                    <Chip
                        size="small"
                        label={level_text}
                        color="primary"
                        style={{ backgroundColor: bcolor, color: color }}
                    />
                </div>

            </AccordionSummary>
            <Typography>
                <AssessmentTemplates initial_template_group_name={template_group_name} template_group_id={template_group_id} />
            </Typography>
        </Accordion>)
    }


    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        history.push('/');
        window.location.reload();
    };

    const addDialogShowSettingsCallback = useCallback((reload: boolean) => {
        setShowSettings(false)
        if (reload) {
            setIsLoaded(false)
        }
    }, [setShowSettings, setIsLoaded]);


    const addDialogShowStatesCallback = useCallback((reload: boolean) => {
        setShowStates(false)
        if (reload) {
            setIsLoaded(false)
        }
    }, [setShowStates, setIsLoaded]);



    const handleDocumentation = () => {
        window.open('https://docsfairp.harc-dev.com.au', "_blank")
    }


    const renderNavMenu = () => {
        return <Popper
            style={{ zIndex: 1000 }}
            open={popperOpen}
            anchorEl={anchorEl}

            placement={"bottom-end"} disablePortal transition>
            {({ TransitionProps }) => (
                <Grow {...TransitionProps}>
                    <Paper>
                        <ClickAwayListener onClickAway={_ => setPopperOpen(false)}>
                            <div>
                                <MenuItem onClick={_ => handleDocumentation()}><HelpIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />Documentation</MenuItem>
                                {write_access && <MenuItem onClick={_ => setShowSettings(true)}><SettingsIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />Settings</MenuItem>}
                                <MenuItem onClick={_ => history.push('/dams/' + assessment?.dam?.project_id)}><ViewModuleIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />View all dams</MenuItem>
                                <MenuItem><AccountCircleIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />Account</MenuItem>
                                <MenuItem onClick={_ => handleLogout()}><ExitToApp style={{ marginLeft: "-10px", paddingRight: "10px" }} />Logout</MenuItem>
                            </div>
                        </ClickAwayListener>
                    </Paper>
                </Grow>)}
        </Popper>
    }

    return (
        <>
            <Toolbar style={{ backgroundColor: "#19b0ef", height: "68px", color: "white", position: "fixed", top: 0, left: 0, right: 0, zIndex: 100 }}>




                <Typography variant={"h5"}
                    style={{ paddingTop: "7px", paddingBottom: "7px" }}>
                    {APPLICATION} | {assessment?.dam?.name}

                </Typography>

                <Typography variant={"body1"}>
                    {!isLoaded && <CircularProgress style={{ marginLeft: "10px", marginRight: "10px", color: "white" }} />}
                </Typography>


                <div style={{ position: "fixed", right: "10px", marginTop: "-3px", }}>

                    {username}


                    <IconButton color="inherit" onClick={(e) => {
                        setPopperOpen(!popperOpen);
                        setAnchorEl(e.currentTarget)
                    }

                    }><MoreVertIcon /></IconButton></div>
                {renderNavMenu()}

                {showSettings && < ProjectSettings closeDialogCallback={addDialogShowSettingsCallback} />}
                {showStates && < States closeDialogCallback={addDialogShowStatesCallback} />}
            </Toolbar>

            {REACT_APP_BRANCH === 'demo' ? <Alert variant="filled" severity="warning">
                This is a demo version, with typical kinds of assessments it does not purport to represent any actual dam.
            </Alert> : null}
            {isLoaded &&
                <Paper variant={"outlined"} style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1, paddingTop: "68px" }}>
                    <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        Overview
                    </Typography>
                    {renderOverview(130, "Location")}
                    {renderSettings(131, "Settings")}
                    {renderConsequenceCatagory(140, "Consequence Categories")}
                    {renderDocuments(150, "References")}

                    <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        Summary
                    </Typography>

                    {renderSummaryKnowledge(100, "State of Knowledge")}

                    {renderSummaryReasonablePracticable(110, "Reasonably Practicable")}

                    {renderInvestigations(120, "Investigations")}

                    <Divider />
                    <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        State of Knowledge
                    </Typography>
                    {renderRiskAssessments(1000, "Group failure modes")}
                    {topLevelGroup.map((tp, index) => {
                        return renderSection(index + 1, tp.name, tp.uuid || 0)
                    })}

                    {APPLICATION === "SFAIRP" && <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        Critical Hazards
                    </Typography>}

                    {APPLICATION === "ALARP" && <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        Failure Modes Prioritisation
                    </Typography>}

                    {APPLICATION === "SFAIRP" && renderCriticalFailureMode(169, "Critical Failure Modes")}


                    {APPLICATION === "ALARP" && renderCriticalFailureMode(169, "Failure Modes Prioritisation")}


                    <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        Control Measures
                    </Typography>
                    {renderControlMeasures(10, "Existing Control Measures", true)}
                    {renderControlMeasures(20, "Additional Control Measures", false)}

                    <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        Reasonably Practicable
                    </Typography>
                    {renderLikelihood(30, "Likelihood")}
                    {renderHarm(112, "Harm")}

                    {renderControlMeasureAdequacy(40, "Existing Control Measure", true)}
                    {renderControlMeasureAdequacy(50, "Additional Control Measures", false)}
                    {renderControlMeasureCosts(60, "Control Measures Costs", false)}
                    {renderControlMeasureAdequacyAssessment(70, "Control Measures Adequacy", true)}

                    {(APPLICATION === "ALARP" || assessmentSettings?.consider_societal_concerns) &&
                        renderSocietalConcerns(80, "Societal Concerns", true)
                    }


                    {assessmentSettings?.is_failure_mode_centric && renderReasonablePracticableCM(90, "Reasonably Practicable Test Assessment ", false)} 
                    
                    {assessmentSettings?.is_failure_mode_centric == false && renderReasonablePracticable(90, "Reasonably Practicable Test Assessment ", false)}
                   
                    {renderFMChart(160, "FN Plot")}

                    <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                        Additional Failure Modes
                    </Typography>

                    {renderAdditonalFailureModes(190, "Additional Failure Modes", false)}

                </Paper>}
            {!isLoaded && <><br /> <CircularProgress style={{ marginLeft: "10px", marginRight: "10px", color: "#969697" }} /></>}
        </>
    );
}

export default Assessment;
